import { Box, Menu, MenuItem, Typography } from "@mui/material"

const CustomDropDown = ({
  header,
  anchorEl,
  open,
  handleClose,
  options = [],
  onSelect,
  style = {},
  menuItemCenter = false
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        disableAutoFocusItem: true,
        sx: {
          // Hide scrollbar
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari, Edge
          },
          overflowY: "auto", // still allow scrolling if needed
        },
      }}
      PaperProps={{
        sx: {
          mt: 2,
          padding: "0 4px",
          backgroundColor: "#fff",
          color: "#000",
          borderRadius: "5px",
          width: style?.width,
          height: style?.height,
          marginLeft: style?.marginLeft,
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari, Edge
          },
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: style.marginLeft ? "0px" : "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}>
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            fontSize: style?.fontSize || "14px",
            // color: "#fff",
            display: !header ? "none" : "flex",
            justifyContent: "center",
            fontFamily: "Poppins",
            whiteSpace: "nowrap",
            padding: "0px 5px",
            height: "30px",
            borderBottom: "0.5px solid #8B8B8B",
            marginBottom: "4px",
          }}>
          {header}
        </Typography>
      </Box>
      {options.map((option, idx) => (
        <MenuItem
          key={idx}
          onClick={() => onSelect(option)}
          sx={{
            borderRadius: "5px",
            fontSize: style.fontSize,
            display: "flex",
            justifyContent: menuItemCenter ? "center" : "flex-start",
            alignItems: menuItemCenter ? "center" : "flex-start",
            textAlign: menuItemCenter ? "center" : "left",
            fontWeight: 400,
            fontFamily: "Karla",
            "&:hover": {
              backgroundColor: "#444444",
              color: "#fff",
            },
          }}>
          {option}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default CustomDropDown
